module.exports = "/dist/fc0cbe442f7b3733c91e982e825c4daa.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-800italic.woff2
// module id = 139
// module chunks = 0